import { Grade } from "@generated/graphql";
import { Button, Card, Slider, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { palette } from "theme";
import { GRADE_BUTTONS } from "../../constants";
import { CompetencyMapGenerationFormValues } from "../../types";

interface GradesBlockProps {
  difficultyGradeLabel: Grade;
}

const GradesBlock = ({ difficultyGradeLabel }: GradesBlockProps) => {
  const form = useFormContext<CompetencyMapGenerationFormValues>();
  const { setValue, watch } = form;
  const difficulty = watch("difficulty");

  const handleSetDifficulty = (nextDifficulty: number) => {
    setValue("difficulty", nextDifficulty, { shouldDirty: true });
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2.5}>
        <Stack spacing={1.5}>
          <Typography variant='h6'>Грейд и сложность</Typography>
          <Stack
            direction='row'
            spacing={1}
            flexWrap='wrap'
            useFlexGap>
            {GRADE_BUTTONS.map((grade) => {
              const isActive = difficultyGradeLabel === grade.label;

              return (
                <Button
                  key={grade.label}
                  color={isActive ? "third" : "secondary"}
                  variant={isActive ? "contained" : "outlined"}
                  onClick={() => handleSetDifficulty(grade.difficulty)}
                  size='small'
                  sx={{
                    fontWeight: 500,
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderColor: isActive ? palette.primary.main : palette.border,
                  }}>
                  {grade.label}
                </Button>
              );
            })}
          </Stack>
        </Stack>
        <Stack>
          <Stack
            direction='row'
            justifyContent='space-between'>
            <Typography
              variant='body16Extra'
              color='text.secondary'>
              Сложность
            </Typography>
            <Typography fontWeight={700}>{difficulty} / 10</Typography>
          </Stack>
          <Slider
            min={0}
            max={10}
            step={1}
            value={difficulty}
            onChange={(_, value) => handleSetDifficulty(value as number)}
          />
          <Typography
            variant='body2'
            color='text.secondary'>
            Junior 0-3 • Middle 4-6 • Senior 7-10
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default GradesBlock;
